// AUTH
export const LOGIN = '/login';
export const ENTER_UID = '/enter-uid';
export const LOGIN_PASSWORD = '/login_password';
export const RESET_PASSWORD_OTP = '/reset-password-otp';
export const CHOOSE_PROFILE = '/choose-profile';
export const SWITCH_PROFILE = '/switch-profile';
export const RESET_PASSWORD = '/reset-password';
export const REGISTRATION = '/registration';
export const VERIFY_DETAILS = '/verify-details';
export const VERIFY_PHONE = '/verify-phone';
export const VERIFY_EMAIL = '/verify-email';
export const SET_PASSWORD = '/set-password';
export const OTP_SCREEN = '/otp-screen';
export const PROFILE_OTP_SCREEN = '/profile-otp-screen';
export const LOGIN_UID_PASSWORD = '/login-uid-password';
// Climate Course
export const CLIMATE_COURSE_LGOIN = '/cl-course-login';

export const ENTER_UID_VK12 = '/vk12';
export const VK12_LOGIN_PASSWORD = '/vk12_login_password';

// DEMO
export const DOCS = '/docs';
export const DEMO_RESOURCE = '/demo-resource';
export const DEMO_AUTO_EVALUATION = '/demo-auto-evaluation';
export const DEMO_QUESTION = '/demo-question';
export const DEMO_RESOURCE_CARD = '/demo-resource-card';
export const QR_RESOLVER = '/qr-resolver';
export const SCREEN_RESOLVER = '/screen-resolver';

// HOME
export const HOME = '/home';

// LIVE QUIZ
export const LIVE_QUIZ_WAITING_ROOM = '/live-quiz-waiting-room';
export const LIVE_QUIZ_ANSWER = '/live-quiz-answer';

// HOMEWORK
export const HOMEWORK_STUDENT_DASHBOARD = '/student-homework-dash';
export const HOMEWORK_ACTIVE = '/active-homework';
export const HOMEWORK_COMPLETED = '/completed-homework';
export const FA_COMPLETED = '/completed-assessment';
export const HOMEWORK_SUBMITTED = '/submitted-homework';

export const HOMEWORK_VIEW_RECOMMENDATION =
  '/student-homework-view-recommendation';
export const HOMEWORK_START_COVER = '/homework-start-cover';
export const FA_START_COVER = '/fa-start-cover';
export const FA_ACTIVE_ASSESSMENT = '/fa-active-assessment';
export const FA_SUBMITTED = '/submitted-assessment';
// Learning Homework (demo)
export const LEARNING_HOMEWORK = '/learning-homework';
// PERFORMANCE
export const PERFORMANCE_STUDENT_DASHBOARD = '/student-performance-dash';
export const PERFORMANCE_STUDENT_CHAPTERWISE =
  '/student-performance-chapterwise';

// LEARN
export const LEARN_DASHBOARD = '/learn-dashboard';
export const LEARN_TOPIC_SELECTION = '/learn-topic-selection';
export const TOPIC_LESSON = '/topic-lesson';
export const LESSON_VIEW = '/lesson-view';
export const RESOURCE_VIEW = '/resource-view';
export const SEE_ALL_LESSON_PLAN = '/see-all-lesson-plan';

// SIDEBAR
export const PROFILE = '/profile';
export const NOTIFICATION = '/notifications';
export const HELP = '/help';
export const FAQ = '/faq';
export const DISCLAIMER = '/disclaimer';
export const CHANGE_PASSWORD = '/change-password';
export const REPORT = '/report';
//OFFLINE
export const OFFLINE_LEARN_DASHBOARD = '/offline/learn-dashboard';
export const OFFLINE_LEARN_TOPIC_SELECTION = '/offline/learn-topic-selection';
export const OFFLINE_TOPIC_LESSON = '/offline/topic-lesson';
export const OFFLINE_LESSON_VIEW = '/offline/lesson-view';
export const OFFLINE_RESOURCE_VIEW = '/offline/resource-lesson';
export const DOWNLOAD_SETTINGS = '/download-settings';

// MCB Login
export const MCB_LOGIN = '/mcb-login';
export const MCB_APP_LOGIN = '/mcb-app-login';

export const SSO_REDIRECT = '/sso-redirect';
// Pal
export const PAL_FRONTEND_BASE_URL = '/pal';
export const PAL_LEARN_DASHBOARD = `${PAL_FRONTEND_BASE_URL}${LEARN_DASHBOARD}`;
export const PAL_KNOWLEDGE_CONCEPTS = `${PAL_FRONTEND_BASE_URL}/knowledge-concepts`;
export const PAL_PRACTICE = `${PAL_FRONTEND_BASE_URL}/practice`;
export const PAL_VIEW_CONTENT = `${PAL_FRONTEND_BASE_URL}/view-content`;
export const PAL_DIAGNOSTIC = `${PAL_FRONTEND_BASE_URL}/diagnostic`;
export const PAL_CHALLENGE = `${PAL_FRONTEND_BASE_URL}/challenge`;
export const PAL_RESET_USER = `${PAL_FRONTEND_BASE_URL}/reset-user`;

// Demo
export const DEMO_PAL_QUESTION = '/demo-pal-question';

// Project
export const Manage_Student_Projects = '/manage-student-projects'
export const project_Start_Cover = '/project-start-cover'
export const Active_Project_Details = '/active-project'
export const Project_Resource_View = '/project-resource-view'
// GIL reports (student's own dashboards)
export const Student_Gil_Journey = '/gil-journey'
export const Student_Gil_Project_Report = '/gil-project-report'
